var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',[_c('h1',[_vm._v(_vm._s(_vm.Title))]),_c('p',[_vm._v(_vm._s(_vm.Description))]),_c('div',{staticClass:"activate"},[_c('ActivationForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }